module.exports = __webpack_public_path__ + "7b2b1adfae8b433c69ba716f7fa63f4c.pdf";